import { render, staticRenderFns } from "./ContactSms.vue?vue&type=template&id=1f5840ea"
import script from "./ContactSms.vue?vue&type=script&lang=js"
export * from "./ContactSms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports